import React, { useEffect, useMemo, useRef, useState } from "react";
import { Outlet, Navigate, useLocation } from "react-router-dom";
import CircularProgress from "@mui/material/CircularProgress";
import { verificarSesionActiva } from "../services/apis";
import {
  clearAuthSession,
  hasAuthSession,
} from "../services/authStorage";

const PrivateRoute = () => {
  const [isAuth, setIsAuth] = useState(null);
  const location = useLocation();
  const aliveRef = useRef(true);
  const publicRoutes = useMemo(() => ["/login", "/seguimientoparte/"], []);

  useEffect(() => {
    aliveRef.current = true;

    const run = async () => {
      try {
        if (publicRoutes.some((r) => location.pathname.startsWith(r))) {
          if (aliveRef.current) setIsAuth(true);
          return;
        }

        if (!hasAuthSession()) {
          if (aliveRef.current) setIsAuth(false);
          return;
        }

        const sessionResponse = await verificarSesionActiva();

        if (sessionResponse?.success !== true) {
          throw new Error(sessionResponse?.message || "No se pudo verificar la sesion");
        }

        if (sessionResponse?.web_restringida) {
          clearAuthSession();
          if (aliveRef.current) setIsAuth(false);
          return;
        }

        if (aliveRef.current) setIsAuth(true);
      } catch (err) {
        const status = err?.response?.status || err?.status;

        if (status === 401) {
          clearAuthSession();
          if (aliveRef.current) setIsAuth(false);
          return;
        }

        console.error("Error validando sesión:", err?.message || err);

        // Si el backend falla puntualmente o hay un error de red,
        // no expulsamos al usuario porque el refresh token puede seguir siendo válido.
        if (aliveRef.current) setIsAuth(true);
      }
    };

    run();

    return () => {
      aliveRef.current = false;
    };
  }, [location.pathname, publicRoutes]);

  if (isAuth === null) {
    return (
      <div style={{ display: "flex", justifyContent: "center", marginTop: 40 }}>
        <CircularProgress />
      </div>
    );
  }

  return isAuth ? (
    <Outlet />
  ) : (
    <Navigate to="/login" replace state={{ from: location }} />
  );
};

export default PrivateRoute;
